<template>
  <div class="view">
    <ProductFrame
      ref="productFrame"
      :title="title + ' : '"
      :showSearchBtn.sync="showSearchBtn"
      remoteId="38"
      :serialNumber="serialNumber"
      @change="onChange"
    >
      <div slot="content">
        <el-input v-model="detail.controlId" placeholder="· 待添加" disabled></el-input>
      </div>
      <div v-if="detail.controlId" slot="middle">
        <div class="testStatus-wrapper">
          <div class="title">信号接收：</div>
          <div class="progress-box">
            <div
              v-for="(item, index) in detail.items"
              :key="item.button"
              :class="{ block: true, pass: result[`btn${index + 1}`] >= 1 }"
            ></div>
          </div>
        </div>
        <LightState @change="onLightChange"></LightState>
      </div>
    </ProductFrame>
  </div>
</template>

<script>
import ProductFrame from './components/ProductFrame'
import LightState from './components/LightState'

export default {
  name: '',
  components: { ProductFrame, LightState },

  props: {
    serialNumber: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '开关'
    }
  },

  data() {
    return {
      showSearchBtn: true,
      detail: {},
      result: {
        btn1: 0,
        btn2: 0,
        btn3: 0,
        btn4: 0,
        light: null
      }
    }
  },

  filters: {},
  computed: {},
  watch: {},

  created() {},

  methods: {
    // 设备改变时执行
    onChange(data) {
      this.detail = data
      this.$emit('change', this.detail)
      this.resetTestResult()
    },

    // 收到 mqtt 信息
    receiveMessage(msg) {
      this.result[`btn${msg.button}`]++
      this.checkout()
    },

    // 灯光测试结果改变时执行
    onLightChange(value) {
      this.result.light = !!value
      this.checkout()
    },

    // 重置测试结果
    resetTestResult() {
      this.result = {
        btn1: 0,
        btn2: 0,
        btn3: 0,
        btn4: 0,
        light: null
      }
    },

    // 检测结果
    checkout() {
      let btnResult = true
      const lightResult = this.result.light

      this.detail.items.forEach((item, index) => {
        if (this.result[`btn${index + 1}`] <= 0) {
          btnResult = false
        }
      })

      if (btnResult && lightResult) {
        this.$emit('resultChange', true)
      } else {
        this.$emit('resultChange', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  .testStatus-wrapper {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .title {
      font-size: 18px;
    }

    .state {
      width: 120px;
      font-size: 20px;
    }

    .progress-box {
      display: flex;
      align-items: center;
      margin-left: 20px;

      .block {
        width: 28px;
        height: 10px;
        margin-right: 10px;
        background-color: #d5d5d5;
      }
      .pass {
        background-color: #09d93f;
      }
    }
  }
}
</style>
